export default {
    en: "English",
    fr: "French",
    pt: "Portuguese",
}